import { createApi } from '@reduxjs/toolkit/query/react';

import { PaginatedResponse } from '../common/dto/common.dto';
import { FilterDto } from '../common/dto/filter.dto';
import { FormDataAssetSearchViewDto, FormDataViewDto } from '../common/dto/formdata.dto';
import customFetchBase from './base.service';

const API_URI = import.meta.env.VITE_REPORT_SERVICE;
const TAG_TYPE = 'Report';

export const reportApi = createApi({
  reducerPath: 'reportApi',
  baseQuery: customFetchBase(`${API_URI}/api/form-data`),
  tagTypes: [TAG_TYPE],
  endpoints: (builder) => ({
    searchReports: builder.mutation<PaginatedResponse<FormDataViewDto>, Partial<{ templateId: string; filters: FilterDto }>>({
      query(o: { templateId: string; filters: FilterDto }) {
        return {
          url: `${o.templateId}`,
          method: 'PATCH',
          body: o.filters,
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
    searchNormalReportByAssetIds: builder.mutation<PaginatedResponse<FormDataAssetSearchViewDto>, Partial<{ assetIds: string[]; filters: FilterDto }>>({
      query(o: { assetIds: string[]; filters: FilterDto }) {
        return {
          url: `assets`,
          method: 'PATCH',
          body: { assetIds: o.assetIds, ...o.filters },
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
    getReport: builder.query<FormDataViewDto, string>({
      query: (id: string) => {
        return `${id}`;
      },
      providesTags: [TAG_TYPE],
    }),
  }),
});

// auto-generated based on the defined endpoints
export const { useSearchReportsMutation, useLazyGetReportQuery, useSearchNormalReportByAssetIdsMutation } = reportApi;
